<script>
  import { t } from '../services/i18n.js';

  let { onAccept, onDecline } = $props();

  let isVisible = $state(true);

  function handleAccept() {
    isVisible = false;
    onAccept?.();
  }

  function handleDecline() {
    isVisible = false;
    onDecline?.();
  }
</script>

{#if isVisible}
  <div class="cookie-consent" role="dialog" aria-labelledby="cookie-title" aria-describedby="cookie-description">
    <div class="cookie-content">
      <div class="cookie-text">
        <h2 id="cookie-title" class="cookie-title">
          🍪 {$t('cookies.title')}
        </h2>
        <p id="cookie-description" class="cookie-description">
          {$t('cookies.description')}
        </p>
      </div>
      <div class="cookie-actions">
        <button class="btn-decline" onclick={handleDecline}>
          {$t('cookies.decline')}
        </button>
        <button class="btn-accept" onclick={handleAccept}>
          {$t('cookies.accept')}
        </button>
      </div>
    </div>
  </div>
{/if}

<style>
  .cookie-consent {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: var(--color-surface);
    border-top: 1px solid var(--color-border);
    box-shadow: var(--shadow-lg);
    z-index: var(--z-modal);
    animation: slideUp 0.3s ease-out;
  }

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  .cookie-content {
    max-width: var(--max-width);
    margin: 0 auto;
    padding: var(--spacing-lg);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-lg);
    flex-wrap: wrap;
  }

  .cookie-text {
    flex: 1;
    min-width: 280px;
  }

  .cookie-title {
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: var(--spacing-xs);
    color: var(--color-text);
  }

  .cookie-description {
    color: var(--color-text-secondary);
    font-size: 0.875rem;
    line-height: 1.5;
  }

  .cookie-actions {
    display: flex;
    gap: var(--spacing-sm);
    flex-shrink: 0;
  }

  .btn-accept,
  .btn-decline {
    padding: var(--spacing-sm) var(--spacing-lg);
    border-radius: var(--border-radius);
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: all var(--transition-fast);
  }

  .btn-accept {
    background-color: var(--color-primary);
    color: white;
    border: none;
  }

  .btn-accept:hover {
    background-color: var(--color-primary-dark);
  }

  .btn-decline {
    background-color: transparent;
    color: var(--color-text-secondary);
    border: 1px solid var(--color-border);
  }

  .btn-decline:hover {
    border-color: var(--color-text-secondary);
    color: var(--color-text);
  }

  @media (max-width: 600px) {
    .cookie-content {
      flex-direction: column;
      text-align: center;
    }

    .cookie-actions {
      width: 100%;
      justify-content: center;
    }
  }
</style>
